export default function ContactSection() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="bg-background-100 rounded-2xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-5">
          <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center bg-primary-100 rounded-xl">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-lg font-heading font-bold text-foreground-900">有料要爆？联系我们</h3>
            <p className="text-sm text-foreground-500 mt-1">欢迎投稿独家线索，我们承诺严格保护爆料人隐私，所有信息加密传输</p>
          </div>
          <a
            href="mailto:tips@chigua.example.com"
            className="px-5 py-2.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            立即投稿
          </a>
        </div>
      </div>
    </section>
  );
}